import gql from 'graphql-tag';

const getPaymentInvoiceQuery = gql`
  query GetPaymentInvoice(
    $videoId: String
    $organisationId: String!
    $isUrl: Boolean
  ) {
    getPaymentInvoice(
      videoId: $videoId
      organisationId: $organisationId
      isUrl: $isUrl
    ) {
      invoiceUrl
      orderId
      createdAt
      invoiceId
      refundedAt
    }
  }
`;

const getPaymentInvoice = () => ({
  query: getPaymentInvoiceQuery,
  module: 'payments',
  buildVariables: ({
    videoId,
    organisationId,
    isUrl
  }: {
    videoId: string;
    organisationId: string;
    isUrl: boolean;
  }) => ({
    videoId,
    organisationId,
    isUrl
  })
});

export default getPaymentInvoice;
